/* CLOUDWEB-18683 Возможность гибкого расширения объёма хранилища для платных пользователей с почти заполненным объёмом.  */

import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

// tempexp_18683-start
interface FlexibleQuotaAsidePromoSettings {
    firstTimePeriod: string;
    restTimePeriod: string;
    successTimePeriod: string;
    firstTimeHits: number;
}

const flexibleQuotaTariffsFeature: 'a' | 'b' | 'c' =
    !IS_MOBILE_BROWSER && !IS_WEBVIEW && !IS_BIZ_USER && getFeature('flexible-quota-tariffs');
const flexibleQuotaTariffsOnlyPaid = IS_PAID_USER && flexibleQuotaTariffsFeature === 'b';
const flexibleQuotaTariffsFreeAndPaid = flexibleQuotaTariffsFeature === 'c';
const flexibleQuotaTariffsAvailable: boolean = flexibleQuotaTariffsOnlyPaid || flexibleQuotaTariffsFreeAndPaid;

export const flexibleQuotaLandingPromo: boolean = flexibleQuotaTariffsAvailable && isFeature('flexible-quota-landing-promo');
export const flexibleQuotaAsidePromo: boolean = flexibleQuotaTariffsAvailable && isFeature('flexible-quota-aside-promo');
export const flexibleQuotaSubscriptionButton: boolean = flexibleQuotaTariffsAvailable && isFeature('flexible-quota-subs-button');
export const flexibleQuotaTurnAsidePromo = isFeature('flexible-quota-turn-aside-promo');
export const flexibleQuotaAsidePromoSettings: FlexibleQuotaAsidePromoSettings = getFeature('flexible-quota-aside-promo-settings');

// flexible_subscription_
const getSource = (source: string, pos: number) => source?.split('_')[pos] || 'balloon';

registerExperiment(
    'flexible-quota',
    flexibleQuotaTariffsFeature,
    [
        AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_SHOW,
        AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_CLICK,
        AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_CLOSE,
        AnalyticEventNames.FLEXIBLE_QUOTA_BUTTON_SHOW,
        AnalyticEventNames.FLEXIBLE_QUOTA_BUTTON_CLICK,
        AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_LAND_SHOW,
        AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_LAND_CLICK,
        AnalyticEventNames.FLEXIBLE_QUOTA_MODAL_SHOW,
        AnalyticEventNames.FLEXIBLE_QUOTA_MODAL_CHANGE,
        AnalyticEventNames.FLEXIBLE_QUOTA_MODAL_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ],
    {
        mapEventNames: {
            FLEXIBLE_QUOTA_PROMO_SHOW: 'bubble-show',
            FLEXIBLE_QUOTA_PROMO_CLICK: 'bubble-click',
            FLEXIBLE_QUOTA_PROMO_CLOSE: 'bubble-сlose',
            FLEXIBLE_QUOTA_BUTTON_SHOW: 'button-show',
            FLEXIBLE_QUOTA_BUTTON_CLICK: 'button-click',
            FLEXIBLE_QUOTA_PROMO_LAND_SHOW: 'block-show',
            FLEXIBLE_QUOTA_PROMO_LAND_CLICK: 'block-click',
            FLEXIBLE_QUOTA_MODAL_SHOW: 'modal-show',
            FLEXIBLE_QUOTA_MODAL_CHANGE: 'modal-change',
            FLEXIBLE_QUOTA_MODAL_CLICK: 'modal-click',
        },
        sendXrayArgs: {
            FLEXIBLE_QUOTA_MODAL_SHOW: ({ source }, { eventName }) => ({
                eventName: `${eventName}-${getSource(source, 2)}`,
            }),
            FLEXIBLE_QUOTA_MODAL_CHANGE: ({ source }, { eventName }) => ({
                eventName: `${eventName}-${getSource(source, 2)}`,
            }),
            FLEXIBLE_QUOTA_MODAL_CLICK: ({ source }, { eventName }) => ({
                eventName: `${eventName}-${getSource(source, 2)}`,
            }),
            TARIFF_BUY: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes('flexible_subscription') ? `${eventName}-${getSource(paySource, 3)}` : eventName,
            }),
            FAST_CHECKOUT_SHOWN: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes('flexible_subscription') ? `${eventName}-${getSource(paySource, 3)}` : eventName,
            }),
        },
    }
);

// tempexp_18683-end
